import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { CaretLeft, CaretRight } from "phosphor-react";

import genreOfmovieFetch from "../../redux/movieOfgenre/movieOfgenreAction";
import genreFetch from "../../redux/genre/genreAction";

// Components
import Search from "../../components/search/index";
import CardShimmer from "../../components/search/card_shimmer";
import Breadcrumb from "../../components/breadcrumb/index";

const Index = () => {
  const params = useParams();
  const dispatch = useDispatch();
  const movieOfgenreState = useSelector((state) => state.movieOfgenreState);
  const genreState = useSelector((state) => state.genreState);
  const [pageCount, setPageCount] = useState(1);
  const [genre, setGenre] = useState(params?.id);

  const gnfind = genreState?.genres?.find(
    (item) => item?.id === parseInt(params?.id)
  );
  useEffect(() => {
    dispatch(genreFetch());
    setGenre(gnfind);
    dispatch(genreOfmovieFetch({ genre_id: genre, page: pageCount }));
  }, [dispatch, pageCount]);

  const NextClick = () => {
    setGenre(gnfind.id);
    setPageCount(pageCount + 1);
  };
  const PrevClick = () => {
    setGenre(gnfind.id);
    if (pageCount > 1) setPageCount(pageCount - 1);
  };
  let ArrS = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];

  return (
    <>
      <div className="p-4 lg:px-24">
        <Breadcrumb curentName={gnfind?.name} />
        <div className="">
          <div className="flex items-center justify-between mb-4">
            <div className="flex items-center space-x-2 text-3xl font-bold">
              <h1>Resualt</h1>
              {movieOfgenreState?.movieOfgenre?.metadata?.total_count ? (
                <h1>
                  {movieOfgenreState?.movieOfgenre?.metadata?.total_count}
                </h1>
              ) : (
                <div className="animate-pulse bg-slate-200 h-6 w-16 rounded-lg"></div>
              )}
            </div>
            <div className="flex mt-0 space-x-2 justify-center z-20 rounded-xl">
              <button
                disabled={
                  movieOfgenreState?.movieOfgenre?.metadata?.current_page ===
                    "1" && true
                }
                onClick={PrevClick}
                className={`${
                  movieOfgenreState?.movieOfgenre?.metadata?.current_page ===
                    "1" && "disabled:opacity-50"
                } flex items-center justify-center p-3 bg-white text-slate-900 border border-slate-300 rounded-xl transition-all duration-300 ease-in-out hover:bg-slate-100`}
              >
                <CaretLeft size={24} />
              </button>
              <p className="p-3">{pageCount}</p>
              <button
                onClick={NextClick}
                disabled={
                  movieOfgenreState?.movieOfgenre?.metadata?.page_count <= 1 ||
                  (movieOfgenreState?.movieOfgenre?.metadata?.page_count ===
                    pageCount &&
                    true)
                }
                className={`${
                  movieOfgenreState?.movieOfgenre?.metadata?.page_count <= 1 ||
                  (movieOfgenreState?.movieOfgenre?.metadata?.page_count ===
                    pageCount &&
                    "disabled:opacity-50")
                } flex items-center justify-center p-3 bg-slate-900 text-white rounded-xl transition-all duration-300 ease-in-out hover:bg-slate-800`}
              >
                <CaretRight size={24} />
              </button>
            </div>
          </div>

          {movieOfgenreState.loading ? (
            <div className="grid grid-cols-2 md:!grid-cols-4 lg:!grid-cols-5 gap-4">
              {ArrS.map((index) => (
                <CardShimmer key={index} />
              ))}
            </div>
          ) : movieOfgenreState.error ? (
            <div className="grid grid-cols-2 md:!grid-cols-4 lg:!grid-cols-5 gap-4">
              {ArrS.map((index) => (
                <CardShimmer key={index} />
              ))}
            </div>
          ) : movieOfgenreState?.movieOfgenre?.data &&
            movieOfgenreState?.movieOfgenre?.data.length > 0 ? (
            <div className="grid grid-cols-2 md:!grid-cols-4 lg:!grid-cols-5 gap-4">
              {movieOfgenreState?.movieOfgenre?.data?.map((movie) => (
                <Search key={movie.id} data={movie} />
              ))}
            </div>
          ) : (
            <div className="flex items-center justify-center bg-slate-100 w-full h-96 rounded-xl">
              <h1>Not Found</h1>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default Index;
